import type { IconProps } from './../../models/icon';

export function ShoppingCartIcon({
  width = 24,
  height = 24,
  secondaryColor = 'var(--color-200)',
  className = '',
}: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      width={width}
      height={height}
      className={className}
    >
      <g clipPath="url(#a)">
        <path
          fill={secondaryColor}
          d="M7.13282 16.7349C6.81779 16.4671 6.61016 16.0945 6.54817 15.6858L5.65674 6.85718H21.3425C21.6287 6.84438 21.9138 6.90357 22.1713 7.02936C22.4288 7.15514 22.6508 7.34349 22.8167 7.57718C22.976 7.79699 23.0809 8.05147 23.1226 8.31971C23.1644 8.58794 23.1418 8.86224 23.0567 9.12004L20.7767 15.9772C20.6574 16.332 20.4253 16.638 20.1157 16.8485C19.8063 17.059 19.4363 17.1624 19.0625 17.1429H8.26245C7.84903 17.1475 7.44784 17.0027 7.13282 16.7349Z"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M0.870117 0.857178H5.0567L6.54813 15.6857C6.61011 16.0945 6.81775 16.4671 7.13278 16.7349C7.4478 17.0027 7.84899 17.1475 8.26241 17.1429H19.0624C19.4363 17.1624 19.8062 17.059 20.1157 16.8485C20.4253 16.638 20.6574 16.332 20.7767 15.9772L23.0567 9.12004C23.1417 8.86224 23.1644 8.58792 23.1225 8.3197C23.0809 8.05147 22.976 7.79698 22.8167 7.57718C22.6508 7.34349 22.4288 7.15514 22.1713 7.02934C21.9138 6.90357 21.6287 6.84437 21.3424 6.85718H5.6567"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M18.7707 23.1429C18.2974 23.1429 17.9136 22.759 17.9136 22.2857C17.9136 21.8124 18.2974 21.4286 18.7707 21.4286C19.244 21.4286 19.6279 21.8124 19.6279 22.2857C19.6279 22.759 19.244 23.1429 18.7707 23.1429Z"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M7.62814 23.1429C7.15474 23.1429 6.771 22.759 6.771 22.2857C6.771 21.8124 7.15474 21.4286 7.62814 21.4286C8.10152 21.4286 8.48528 21.8124 8.48528 22.2857C8.48528 22.759 8.10152 23.1429 7.62814 23.1429Z"
        />
      </g>
    </svg>
  );
}
